import { format, parseISO } from 'date-fns';

export function formatDate(rawDate?: string | null): string {
  if (!rawDate) {
    return '';
  }

  const date = parseISO(rawDate);
  return format(date, 'yyyy-MM-dd');
}
